import axios, { AxiosError, AxiosRequestConfig } from 'axios'
import ErrorCode from 'forms/ErrorCodes'
import { getDeviceId, logDeviceId } from 'utils/deviceId'
import uuidv4 from 'utils/uuid'

interface IApiFetchOptions extends AxiosRequestConfig {
  withAuth?: boolean
  formData?: boolean
}

const logDeviceIdOnGeoRestriction = (data: any) => {
  if (data?.code === ErrorCode.GEO_RESTRICTED) {
    logDeviceId()
  }
}

const apiFetch = (url: string, options: IApiFetchOptions = {}) => {
  const defaultOptions: IApiFetchOptions = {
    method: `GET`,
    headers: {
      'Content-Type': `application/json`,
      'X-Trace-Id': uuidv4(),
      'X-Device-Id': getDeviceId(),
    },
    validateStatus: (status) => status !== 401,
    baseURL: process.env.NEXT_PUBLIC_REACT_APP_API_URL,
  }

  return axios(url, {
    ...defaultOptions,
    ...options,
    headers: { ...defaultOptions.headers, ...(options.headers || {}) },
  })
    .then((response) => {
      logDeviceIdOnGeoRestriction(response.data)

      return response
    })
    .catch((error: AxiosError) => {
      logDeviceIdOnGeoRestriction(error?.response?.data)

      throw error
    })
}

export default apiFetch
